import React from 'react';

import {
    Form,
    Button,
    Modal,
    Input,
    message
} from 'antd';

import {
    _postAddInternationalShippingInfo
} from "../../services";

class InternationalShippingInfoButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            shippingInfoModalVisible: false
        };
    }

    render() {
        return (
            <div>
                <Button
                    onClick={this.openModal}>
                    International Shipping Info
                </Button>
                {this.state.shippingInfoModalVisible && <Modal
                    title="International Shipping Info"
                    visible={this.state.shippingInfoModalVisible}
                    onCancel={() => this.closeModal()}
                    footer={false}
                >
                    {this.renderForm()}
                </Modal>}
            </div>
        );
    }

    openModal = () => {
        this.setState({
            shippingInfoModalVisible: true
        });
    };

    closeModal = () => {
        this.setState({
            shippingInfoModalVisible: false
        });
    };

    renderForm = () => {

        const { getFieldDecorator } = this.props.form;
        const { internationalShippingInfo } = this.props;

        const layout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
        };

        const tailLayout = {
            wrapperCol: { offset: 10, span: 4 },
        };

        return (
            <Form
                {...layout}
                onSubmit={this.handleSubmit}>

                <Form.Item label="IncoTerms">
                    {getFieldDecorator('incoterms', {
                        initialValue: internationalShippingInfo ? internationalShippingInfo.incoterms : '',
                        rules: [{ required: true }],
                    })(
                        <Input placeholder="IncoTerms" id="incoterms" />
                    )}
                </Form.Item>
                <Form.Item label="Net Weight">
                    {getFieldDecorator('netWeight', {
                        initialValue: internationalShippingInfo ? internationalShippingInfo.netWeight : '',
                        rules: [{ required: true }],
                    })(
                        <Input placeholder="Net Weight" id="netWeight" />
                    )}
                </Form.Item>
                <Form.Item label="Gross Weight">
                    {getFieldDecorator('grossWeight', {
                        initialValue: internationalShippingInfo ? internationalShippingInfo.grossWeight : '',
                        rules: [{ required: true }],
                    })(
                        <Input placeholder="Gross Weight" id="grossWeight" />
                    )}
                </Form.Item>
                <Form.Item label="Dimension">
                    {getFieldDecorator('dimension', {
                        initialValue: internationalShippingInfo ? internationalShippingInfo.dimension : '',
                        rules: [{ required: true }],
                    })(
                        <Input placeholder="Dimension" id="dimension" />
                    )}
                </Form.Item>
                <Form.Item label="Total Box">
                    {getFieldDecorator('totalBox', {
                        initialValue: internationalShippingInfo ? internationalShippingInfo.totalBox : '',
                        rules: [{ required: true }],
                    })(
                        <Input placeholder="Total Box" id="totalBox" />
                    )}
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit">
                        Submit
                    </Button>
                </Form.Item>

            </Form>
        );
    };

    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFields((err, values) => {
            if (!err) {
                var { incoterms, netWeight, grossWeight, dimension, totalBox } = values;

                _postAddInternationalShippingInfo({
                    cartId: this.props.cartId,
                    incoterms,
                    netWeight,
                    grossWeight,
                    dimension,
                    totalBox
                })
                    .then(_cart => {
                        message.success('Add success!');
                        this.closeModal();
                    });

            }

        });

    };

}

export default Form.create()(InternationalShippingInfoButton);


// WEBPACK FOOTER //
// ./src/components/orders-v2/international-shipping-info-button.js